module.exports = __webpack_public_path__ + "media/country_flags/tg-dbd93358.png";